export default __webpack_public_path__ + "static/media/Background_00113.5f7a03b5.png";